/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiBroadcastFixArchiveStatisticsPost$Params {
  prefix?: string;
}

export function apiBroadcastFixArchiveStatisticsPost(http: HttpClient, rootUrl: string, params?: ApiBroadcastFixArchiveStatisticsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiBroadcastFixArchiveStatisticsPost.PATH, 'post');
  if (params) {
    rb.query('prefix', params.prefix, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiBroadcastFixArchiveStatisticsPost.PATH = '/api/Broadcast/fix-archive-statistics';
